<template>
  <div class="row">
    <div class="custom-header mt-4">
      <h3>{{ $t("PROPERTIES.APPLICABLES_FEES") }}</h3>
      <div class="">
        <base-button
            v-if="$currentUserCan($permissions.PERM_CREATE_OTHER_FEES)"
            @click="openApplyFeeModal()"
            type="button"
            class="elite-button add"
        >
          <span class="btn-inner--icon">
            <i class="far fa-plus-circle"></i>
          </span>
          <span class="btn-inner--text">
            {{ $t("AUCTIONS.APPLY_FEES") }}
          </span>
        </base-button>
      </div>
    </div>

    <div class="row col-12">
      <div class="page-wrapper-table">
        <div class="page-wrapper-table-body">
          <div class="page-wrapper-table-body-inner">
            <el-table
              class="align-items-center table-flush"
              header-row-class-name="thead-light"
              :data="fees"
            >
              <el-table-column :label="$t('PROPERTIES.TYPE_FEE')" min-width="30">
                <template v-slot="{ row }">
                  {{ $t(`PROPERTIES.TYPE_${row.type_fee}`) }}
                </template>
              </el-table-column>

              <el-table-column :label="$t('AUCTIONS.FEE_VALUE')" min-width="30">
                <template v-slot="{ row }">
                  <span v-if="row.amount">{{row.type_fee == 'PERCENTAGE' ? row.auction_amount+'%' : $formatCurrency(row.auction_amount)}}</span>
                  <span v-else>-</span>
                </template>
              </el-table-column>

              <el-table-column :label="$t('COMMON.PROPERTIES')" min-width="30">
                <template v-slot="{ row }">
                  <span v-if="row.amount">{{row.total}}</span>
                  <span v-else>-</span>
                </template>
              </el-table-column>

              <el-table-column :label="$t('AUCTIONS.FEE_AMOUNT_BY_PROPERTY_COLUMN')" min-width="40">
                <template v-slot="{ row }">
                  <span v-if="row.amount">{{row.type_fee == 'BY_PROPERTY' ? $formatCurrency(row.auction_amount/row.total) : '-'}}</span>
                  <span v-else>-</span>
                </template>
              </el-table-column>

              <el-table-column :label="$t('PROPERTIES.DATE_FEE')" min-width="30">
                <template v-slot="{ row }">
                  <span v-if="row.amount">{{ $formatDate(row.date) }}</span>
                  <span v-else>-</span>
                </template>
              </el-table-column>

              <el-table-column min-width="10">
                <div slot-scope="{ row }" class="table-actions">
                  <el-tooltip :content="$t('COMMON.EDIT')" placement="top">
                    <a
                      type="text"
                      @click="openApplyFeeModal(row)"
                      class="table-action"
                      data-toggle="tooltip"
                      style="cursor: pointer"
                    >
                      <i class="fal fa-edit"></i>
                    </a>
                  </el-tooltip>
                </div>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Table, TableColumn, Tooltip, Button } from "element-ui";
import formMixin from "@/mixins/form-mixin";
import Users from "@/components/Users.vue";

export default {
  name: "auction-applied-fees-list-table",

  components: {
    [Tooltip.name]: Tooltip,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Button.name]: Button,
    Users,
  },

  mixins: [formMixin],

  props: {
    filterAuctionId: {
      handler: "getListDebounced",
      immediate: true,
    },
    query: {
      handler: "getListDebounced",
      immediate: true,
    },
  },

  data() {
    return {
      propertyFees: [],
      propertyFeeData: {},
      fees: [],
    };
  },

  computed: {},
  created(){
    this.getList();
  },

  methods: {
    getListDebounced: _.debounce(function () {
      this.getList();
    }, 300),
    openApplyFeeModal(propertyFee) {
      this.$emit("onOpenApplyFeeModal", propertyFee);
    },
    async getList() {
      try {
        this.loading = true;
        let params = {
          ...(this.sort ? { sort: this.sort } : {}),
          filter: {
            ...(this.query ? { search: this.query } : {}),
          },
        };

        if (this.filterAuctionId) {
          params = {
            ...params,
            filter: {
              ...params.filter,
              auction: this.filterAuctionId,
            },
          };
        }
        await this.$store.dispatch("propertyFees/list", params);
        this.propertyFees = this.$store.getters["propertyFees/list"];
        this.fees = Object.values(
          this.propertyFees.reduce((acc, item) => {
            if (!acc[item.iteration]) {
              acc[item.iteration] = { id: item.id,type_fee: item.type_fee, amount: item.amount, auction_amount: item.auction_amount, date: item.date ? item.date.substring(0, 10) : null, total: 0 };
            }
            acc[item.iteration].total++;
            return acc;
          }, {})
        );
        console.log(this.fees);
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
      }
    },
  },

  watch: {},
};
</script>

<!-- <style>
.purchasesOrder-item-excerpt p,
.purchasesOrder-item-excerpt,
.purchasesOrder-item-excerpt * {
  font-size: 0.7rem;
}
</style> -->
